import { render, staticRenderFns } from "./BaseAlert2.vue?vue&type=template&id=2eda2d92&scoped=true&"
import script from "./BaseAlert2.vue?vue&type=script&lang=js&"
export * from "./BaseAlert2.vue?vue&type=script&lang=js&"
import style0 from "./BaseAlert2.vue?vue&type=style&index=0&id=2eda2d92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eda2d92",
  null
  
)

export default component.exports